import React from 'react';
import { useTranslation } from 'react-i18next';

import clsx from 'clsx';

export interface SelectOption {
  value: string | number;
  label: string;
}

export interface IBadgeSwitchMobile {
  title: string;
  value: string;
  setValue: (value: string) => void;
  icon?: React.ReactNode;
  options: SelectOption[];
  className?: string;
}

export const BadgeSwitchMobile = ({
  title,
  value,
  setValue,
  icon,
  options = [],
  className,
}: IBadgeSwitchMobile) => {
  const { t } = useTranslation();

  const handleClick = () => {
    if (!options.length) return;

    const currentIndex = options.findIndex((options) => options.value === value);
    const nextIndex = currentIndex === -1 ? 0 : (currentIndex + 1) % options.length;

    setValue(options[nextIndex].value.toString());
  };

  return (
    <div className={clsx('relative cursor-pointer', className)} onClick={handleClick}>
      <div className={`flex flex-col justify-between gap-1 text-sm text-white text-opacity-70`}>
        <div className="flex items-center gap-1">
          <span>{title}</span>
          {icon && <span>{icon}</span>}
        </div>
        <div className="text-md text-light-grape">
          {t(options.find((option) => option.value === value)?.label || '')}
        </div>
      </div>
    </div>
  );
};
